import { BSC_CHAIN_ID, SALE_CHAIN_DECIMALS } from "./sale-flow.constants";
import {
  getSupportedNetworkChainIds,
  isSupportedNetworkChainId,
  normalizeChainId,
} from "app/utils/network-chain.utils";

export { normalizeChainId };

export const getSupportedChainIds = (
  supportedNetworks: Parameters<typeof getSupportedNetworkChainIds>[0] = []
): number[] => {
  return getSupportedNetworkChainIds(supportedNetworks);
};

export const isSupportedChainId = (
  chainId: number | null,
  supportedChainIds: number[]
): chainId is number => {
  return isSupportedNetworkChainId(chainId, supportedChainIds);
};

export const getStablecoinDecimals = (chainId: number): number => {
  return chainId === BSC_CHAIN_ID
    ? SALE_CHAIN_DECIMALS.bscMainnet
    : SALE_CHAIN_DECIMALS.defaultStablecoin;
};
